import { Agent as HttpsAgent } from 'https';
import { Agent as HttpAgent } from 'http';

const options = {
  keepAlive: true,
  timeout: 15 * 1000,
};

export const httpsAgent = new HttpsAgent(options);
export const httpAgent = new HttpAgent(options);
